const SelectedFilters = ({ selectedOption, selectedItems, handleRemove, handleClearAll, setIsShowMatchingContacts }) => {
    return (
        <>
            <p className="mt-2">Selected Filters {selectedItems?.length > 0 && `(${selectedItems?.length})`}<span className="float-end fw-semibold cursor-pointer" style={{ fontSize: '12px' }} onClick={handleClearAll}>Clear all</span></p>
            <p>{selectedOption}</p>

            <div className="d-flex flex-wrap mt-2 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 39.8vh)' }}>
                {selectedItems.map((option) => (
                    <div className="select__multi-value css-1p3m7a8-multiValue" key={option.id}>
                        <div className="select__multi-value__label css-9jq23d">{option.name}</div>
                        <div role="button" className="select__multi-value__remove css-v7duua" aria-label="Remove Blue"
                            onClick={() => handleRemove(option.id)}
                        >
                            <svg height="14" width="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-8mmkcg">
                                <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z">
                                </path>
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
            <div style={{ position: 'absolute', bottom: 0 }}>
                <p className="text-center">5 Contacts Available</p>
                <button type="button" className="btn btn-primary btn-blue"
                    onClick={() => setIsShowMatchingContacts(true)}>
                    <span>See Matching Contacts</span>
                </button>
            </div>
        </>
    )
}
export default SelectedFilters;